import { useNavigate } from "react-router-dom";

function Home() {
  const navigate = useNavigate();

  const handleClick = (event, path) => {
    event.preventDefault();
    navigate(path);
  };
  const handleClickNoAction = (event) => {
    event.preventDefault();
  };

  return (
    <div className="sections_group">
      <div className="entry-content">
        <div
          className="section mcb-section"
          style={{ paddingTop: 0, paddingBottom: 0 }}
        >
          <div className="section_wrapper mcb-section-inner">
            <div className="wrap mcb-wrap one  valign-top clearfix">
              <div className="mcb-wrap-inner">
                <div className="column mcb-column one column_column "></div>
                <div className="column mcb-column one-fourth column_quick_fact">
                  <div className="quick_fact animate-math">
                    <div className="number-wrapper">
                      <span className="number" data-to={3}>
                        2+
                      </span>
                    </div>
                    <h3 className="title">JAAR ERVARING</h3>
                    <hr className="hr_narrow" />
                    <div className="desc" />
                  </div>
                </div>
                <div className="column mcb-column one-fourth column_quick_fact">
                  <div className="quick_fact animate-math">
                    <div className="number-wrapper">
                      <span className="number" data-to={12}>
                        12
                      </span>
                    </div>
                    <h3 className="title">NETWERK IN 12 LANDEN</h3>
                    <hr className="hr_narrow" />
                    <div className="desc" />
                  </div>
                </div>
                <div className="column mcb-column one-fourth column_quick_fact">
                  <div className="quick_fact animate-math">
                    <div className="number-wrapper">
                      <span className="number" data-to={5}>
                        5
                      </span>
                    </div>
                    <h3 className="title">SERVICE IN 5 TALEN</h3>
                    <hr className="hr_narrow" />
                    <div className="desc" />
                  </div>
                </div>
                <div className="column mcb-column one-fourth column_quick_fact">
                  <div className="quick_fact animate-math">
                    <div className="number-wrapper">
                      <span className="number" data-to={3}>
                        3
                      </span>
                    </div>
                    <h3 className="title">
                      OPLEVERING BINNEN GEMIDDELD 3 MAANDEN
                    </h3>
                    <hr className="hr_narrow" />
                    <div className="desc" />
                  </div>
                </div>
                <div className="column mcb-column one column_divider">
                  <hr />
                </div>
              </div>
            </div>
          </div>
        </div>
        <div
          className="section mcb-section"
          style={{
            paddingTop: 90,
            paddingBottom: 50,
            backgroundImage:
              "url(content/architect2/images/home_architect2_sectionbg1.jpg)",
            backgroundRepeat: "no-repeat",
            backgroundPosition: "center",
          }}
        >
          <div className="section_wrapper mcb-section-inner">
            <div className="wrap mcb-wrap one  valign-top clearfix">
              <div className="mcb-wrap-inner">
                <div className="column mcb-column one column_offer_thumb">
                  <div className="offer_thumb">
                    <ul className="offer_thumb_ul">
                      <li className="offer_thumb_li id_1">
                        <div className="image_wrapper">
                          <img
                            width={800}
                            height={551}
                            src="content/architect2/images/home_architect2_offerslider1.jpg"
                            className="scale-with-grid wp-post-image"
                            alt=""
                          />{" "}
                        </div>
                        <div className="desc_wrapper">
                          <div className="desc">
                            <div
                              style={{
                                textAlign: "right",
                                margin: "0 2% 0 10%",
                              }}
                            >
                              <h2
                                className="themecolor"
                                style={{ marginBottom: 3 }}
                              >
                                &#123;1&#125;
                              </h2>
                              <h2>EXPERTISE</h2>
                              <h6>We hebben expertise in IT-oplossingen.</h6>
                              <p>
                                Bij App Makelaar bieden we toonaangevende
                                technologische oplossingen, ondersteund door een
                                breed scala aan IT-experts. Ons team is
                                gespecialiseerd in het leveren van op maat
                                gemaakte oplossingen die bedrijven helpen
                                efficiënter en effectiever te functioneren. Met
                                een diepgaand begrip van de nieuwste
                                technologieën, staan wij klaar om uw bedrijf
                                naar een hoger niveau te tillen..{" "}
                              </p>
                              <p>
                                <a
                                  href="/info"
                                  onClick={(e) => handleClick(e, "/info")}
                                >
                                  Lees meer …
                                </a>{" "}
                              </p>
                            </div>
                          </div>
                        </div>
                        <div className="thumbnail" style={{ display: "none" }}>
                          <img
                            src="content/architect2/images/home_architect2_contentslider_icon1.png"
                            className="scale-with-grid"
                            alt=""
                          />{" "}
                        </div>
                      </li>
                      <li className="offer_thumb_li id_2">
                        <div className="image_wrapper">
                          <img
                            width={800}
                            height={551}
                            src="content/architect2/images/home_architect2_offerslider2.jpg"
                            className="scale-with-grid wp-post-image"
                            alt=""
                          />{" "}
                        </div>
                        <div className="desc_wrapper">
                          <div className="desc">
                            <div
                              style={{
                                textAlign: "right",
                                margin: "0 2% 0 10%",
                              }}
                            >
                              <h2
                                className="themecolor"
                                style={{ marginBottom: 3 }}
                              >
                                [2]
                              </h2>
                              <h2>OPLOSSINGEN</h2>
                              <h6>
                                Elk technisch probleem heeft een oplossing.
                              </h6>
                              <p>
                                Bijna altijd is de sleutel tot de oplossing
                                mensen vinden met de juiste vaardigheden. Wij
                                hebben langdurige relaties opgebouwd met mensen
                                die over de juiste vaardigheden beschikken, wat
                                de kern vormt van ons aanhoudend succes.{" "}
                              </p>
                              <p>
                                <a
                                  href="/info"
                                  onClick={(e) => handleClick(e, "/info")}
                                >
                                  Lees meer …
                                </a>{" "}
                              </p>
                            </div>
                          </div>
                        </div>
                        <div className="thumbnail" style={{ display: "none" }}>
                          <img
                            src="content/architect2/images/home_architect2_contentslider_icon2.png"
                            className="scale-with-grid"
                            alt=""
                          />{" "}
                        </div>
                      </li>
                      <li className="offer_thumb_li id_3">
                        <div className="image_wrapper">
                          <img
                            width={800}
                            height={551}
                            src="content/architect2/images/home_architect2_offerslider3.jpg"
                            className="scale-with-grid wp-post-image"
                            alt=""
                          />{" "}
                        </div>
                        <div className="desc_wrapper">
                          <div className="desc">
                            <div
                              style={{
                                textAlign: "right",
                                margin: "0 2% 0 10%",
                              }}
                            >
                              <h2
                                className="themecolor"
                                style={{ marginBottom: 3 }}
                              >
                                (3)
                              </h2>
                              <h2>NETWERK</h2>
                              <h6>
                                Kosteneffectiviteit door internationale
                                connecties.
                              </h6>
                              <p>
                                App Makelaar begrijpt de waarde van een
                                uitgebreid internationaal netwerk. Door samen te
                                werken met ons, profiteert uw bedrijf van ons
                                wereldwijde bereik en de daarmee gepaard gaande
                                kostenbesparingen. Onze connecties in
                                verschillende landen stelt ons in staat om
                                unieke, grensoverschrijdende oplossingen te
                                bieden, die niet alleen kostenbesparend zijn
                                maar ook uw bedrijf een concurrentievoordeel
                                bieden.{" "}
                              </p>
                              <p>
                                <a
                                  href="/info"
                                  onClick={(e) => handleClick(e, "/info")}
                                >
                                  Lees meer …
                                </a>{" "}
                              </p>
                            </div>
                          </div>
                        </div>
                        <div className="thumbnail" style={{ display: "none" }}>
                          <img
                            src="content/architect2/images/home_architect2_contentslider_icon3.png"
                            className="scale-with-grid"
                            alt=""
                          />{" "}
                        </div>
                      </li>
                    </ul>
                    <div className="slider_pagination" />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div
          className="section mcb-section"
          style={{ paddingTop: 40, paddingBottom: 40 }}
        >
          <div className="section_wrapper mcb-section-inner">
            <div className="wrap mcb-wrap one  valign-top clearfix">
              <div className="mcb-wrap-inner">
                <div className="column mcb-column three-fifth column_column ">
                  <div className="column_attr">
                    <h2 style={{ margin: 0 }}>Essentiële IT-diensten</h2>
                  </div>
                </div>
                <div className="column mcb-column two-fifth column_column ">
                  <div
                    className="column_attr align_right"
                    style={{
                      padding: "10px 5px",
                      borderBottom: "1px solid rgba(0,0,0,.2)",
                    }}
                  >
                    <a href="/info" onClick={(e) => handleClick(e, "/info")}>
                      Lees meer over wat wij voor u kunnen betekenen.{" "}
                      <i className="icon-right-open" />
                    </a>
                  </div>
                </div>
                <div className="column mcb-column one column_divider">
                  <hr className="no_line" style={{ margin: "0 auto 20px" }} />
                </div>
                <div className="column mcb-column one-third column_column ">
                  <div className="column_attr" style={{ padding: "0 10% 0 0" }}>
                    <h4 style={{ marginLeft: 30 }}>Webdesign en SEO</h4>
                    <hr className="no_line" style={{ margin: "0 auto 20px" }} />
                    <div className="image_frame image_item no_link scale-with-grid alignnone no_border">
                      <div className="image_wrapper">
                        <img
                          className="scale-with-grid"
                          src="content/architect2/images/home_architect2_sep.png"
                          width={100}
                          height={3}
                          alt=""
                        />{" "}
                      </div>
                    </div>
                    <hr className="no_line" style={{ margin: "0 auto 20px" }} />
                    <div style={{ marginLeft: 30 }}>
                      <h6>
                        Ons team van deskundige webontwerpers en
                        SEO-specialisten werkt samen om een aantrekkelijke,
                        responsieve website voor uw bedrijf te creëren. We
                        zorgen ervoor dat uw website niet alleen esthetisch
                        aanspreekt, maar ook geoptimaliseerd is voor
                        zoekmachines, waardoor uw online zichtbaarheid en
                        klantenbereik worden vergroot.
                      </h6>
                      <hr
                        className="no_line"
                        style={{ margin: "0 auto 30px" }}
                      />
                      <a href="/info" onClick={(e) => handleClick(e, "/info")}>
                        Lees meer ...
                      </a>
                    </div>
                  </div>
                </div>
                <div className="column mcb-column one-third column_column ">
                  <div className="column_attr" style={{ padding: "0 10% 0 0" }}>
                    <h4 style={{ marginLeft: 30 }}>Ontwerp van Apps</h4>
                    <hr className="no_line" style={{ margin: "0 auto 20px" }} />
                    <div className="image_frame image_item no_link scale-with-grid alignnone no_border">
                      <div className="image_wrapper">
                        <img
                          className="scale-with-grid"
                          src="content/architect2/images/home_architect2_sep.png"
                          width={100}
                          height={3}
                          alt=""
                        />{" "}
                      </div>
                    </div>
                    <hr className="no_line" style={{ margin: "0 auto 20px" }} />
                    <div style={{ marginLeft: 30 }}>
                      <h6>
                        Wij bieden geïntegreerde webdesign- en SEO-diensten om
                        uw online aanwezigheid te maximaliseren
                      </h6>
                      <p>
                        Onze deskundige webontwerpers en SEO-specialisten werken
                        samen om ervoor te zorgen dat uw website niet alleen
                        visueel aantrekkelijk is, maar ook hoog scoort in
                        zoekmachineresultaten.
                      </p>
                      <hr
                        className="no_line"
                        style={{ margin: "0 auto 30px" }}
                      />
                      <a href="/info" onClick={(e) => handleClick(e, "/info")}>
                        Lees meer ...
                      </a>
                    </div>
                  </div>
                </div>
                <div className="column mcb-column one-third column_column ">
                  <div className="column_attr" style={{ padding: "0 10% 0 0" }}>
                    <h4 style={{ marginLeft: 30 }}>Automatisering</h4>
                    <hr className="no_line" style={{ margin: "0 auto 20px" }} />
                    <div className="image_frame image_item no_link scale-with-grid alignnone no_border">
                      <div className="image_wrapper">
                        <img
                          className="scale-with-grid"
                          src="content/architect2/images/home_architect2_sep.png"
                          width={100}
                          height={3}
                          alt=""
                        />{" "}
                      </div>
                    </div>
                    <hr className="no_line" style={{ margin: "0 auto 20px" }} />
                    <div style={{ marginLeft: 30 }}>
                      <h6>
                        Wij zijn gespecialiseerd in het automatiseren van
                        bedrijfsprocessen om efficiëntie en productiviteit te
                        verhogen.
                      </h6>
                      <p>
                        Door routinematige taken te automatiseren, helpen we u
                        tijd en middelen te besparen, waardoor u zich kunt
                        concentreren op de groei van uw bedrijf.
                      </p>
                      <hr
                        className="no_line"
                        style={{ margin: "0 auto 30px" }}
                      />
                      <a href="/info" onClick={(e) => handleClick(e, "/info")}>
                        Lees meer ...
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div
          className="section mcb-section"
          style={{
            paddingTop: 90,
            paddingBottom: 50,
            backgroundColor: "#e9edf1",
            backgroundImage:
              "url(content/architect2/images/home_architect2_pattern1.jpg)",
            backgroundRepeat: "repeat",
            backgroundPosition: "center top",
          }}
        >
          <div className="section_wrapper mcb-section-inner">
            <div
              className="wrap mcb-wrap one-fourth  valign-top clearfix"
              style={{ padding: "0 1%" }}
            >
              <div className="mcb-wrap-inner">
                <div className="column mcb-column one column_column ">
                  <div className="column_attr align_right">
                    <div
                      style={{
                        display: "inline-block",
                        borderRight: "1px solid #ccced3",
                        textAlign: "right",
                        padding: "50px 0 0 0",
                      }}
                    >
                      <h4 style={{ margin: 10 }}>ONS</h4>
                      <span
                        style={{
                          display: "inline-block",
                          background: "#b8a892",
                          color: "#fff",
                          padding: "4px 12px",
                          fontWeight: 700,
                          letterSpacing: 3,
                        }}
                      >
                        TEAM
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div
              className="wrap mcb-wrap one-fourth  column-margin-20px valign-top clearfix"
              style={{ padding: "0 1%" }}
            >
              <div className="mcb-wrap-inner">
                <div className="column mcb-column one column_image">
                  <div className="image_frame image_item scale-with-grid aligncenter no_border">
                    <div className="image_wrapper">
                      <a onClick={handleClickNoAction}>
                        <div className="mask" />
                        <img
                          className="scale-with-grid"
                          src="content/architect2/images/kambiz.jpeg"
                          width={780}
                          height={880}
                          alt=""
                        />
                      </a>
                      <div className="image_links">
                        <a
                          onClick={handleClickNoAction}
                          className="link"
                        >
                          <i className="icon-link" />
                        </a>{" "}
                      </div>
                    </div>
                  </div>
                </div>
                <div className="column mcb-column one column_column">
                  <div className="column_attr">
                    <h4>Kambiz Achmad</h4>
                    <span
                      style={{
                        display: "inline-block",
                        background: "#b8a892",
                        color: "#fff",
                        padding: "4px",
                        fontWeight: 400,
                        letterSpacing: 3,
                      }}
                    >
                      Clientmanager
                    </span>
                    <p>
                      Met meer dan een 10 jaar ervaring in IT, excelleert Kambiz
                      in het snel doorgronden van klantbehoeften en het
                      efficiënt samenstellen van expertteams voor
                      maatoplossingen. Zijn aanpak garandeert hoogwaardige
                      resultaten en klanttevredenheid, waarmee hij zich
                      onderscheidt als een cruciale schakel in elk IT-project.
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <div
              className="wrap mcb-wrap one-fourth  column-margin-20px valign-top clearfix"
              style={{ padding: "0 1%" }}
            >
              <div className="mcb-wrap-inner">
                <div className="column mcb-column one column_image">
                  <div className="image_frame image_item scale-with-grid aligncenter no_border">
                    <div className="image_wrapper">
                      <a onClick={handleClickNoAction}>
                        <div className="mask" />
                        <img
                          className="scale-with-grid"
                          src="content/architect2/images/ali2.jpeg"
                          width={780}
                          height={880}
                          alt=""
                        />
                      </a>
                      <div className="image_links">
                        <a
                          onClick={handleClickNoAction}
                          className="link"
                        >
                          <i className="icon-link" />
                        </a>{" "}
                      </div>
                    </div>
                  </div>
                </div>
                <div className="column mcb-column one column_column ">
                  <div className="column_attr">
                    <h4>Ali Alizay</h4>
                    <span
                      style={{
                        display: "inline-block",
                        background: "#b8a892",
                        color: "#fff",
                        padding: "4px",
                        fontWeight: 400,
                        letterSpacing: 3,
                      }}
                    >
                      Projectmanager
                    </span>
                    <p>
                      Met meer dan vijf jaar ervaring in IT en een achtergrond
                      als developer, onderscheidt Ali zich door zijn passie voor
                      het verbinden van klanten en opdrachtnemers. Zijn
                      technische expertise en diepgaand inzicht in zowel de
                      behoeften van de klant als de mogelijkheden van de
                      uitvoerders, maken hem een essentiële schakel in het
                      succesvol samenbrengen van partijen voor optimale
                      projectresultaten.
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <div
              className="wrap mcb-wrap one-fourth  column-margin-20px valign-top clearfix"
              style={{ padding: "0 1%" }}
            >
              <div className="mcb-wrap-inner">
                <div className="column mcb-column one column_image">
                  <div className="image_frame image_item scale-with-grid aligncenter no_border">
                    <div className="image_wrapper">
                      <a onClick={handleClickNoAction}>
                        <div className="mask" />
                        <img
                          className="scale-with-grid"
                          src="content/architect2/images/liceth2.jpeg"
                          width={780}
                          height={880}
                          alt=""
                        />
                      </a>
                      <div className="image_links">
                        <a
                          onClick={handleClickNoAction}
                          className="link"
                        >
                          <i className="icon-link" />
                        </a>{" "}
                      </div>
                    </div>
                  </div>
                </div>
                <div className="column mcb-column one column_column ">
                  <div className="column_attr">
                    <h4>Liceth Muñoz</h4>
                    <span
                      style={{
                        display: "inline-block",
                        background: "#b8a892",
                        color: "#fff",
                        padding: "4px",
                        fontWeight: 400,
                        letterSpacing: 3,
                      }}
                    >
                      Accountmanager (LATAM)
                    </span>
                    <p>
                      Liceth, met meer dan drie jaar ervaring in de IT-sector,
                      is gespecialiseerd in het werven van talenten uit
                      Latijns-Amerika. Haar expertise en diepgaande kennis van
                      de LATAM-markt zijn cruciaal voor het aantrekken van
                      topkandidaten. Liceth's vaardigheden in netwerken en
                      relatiebeheer dragen bij aan het versterken en uitbreiden
                      van ons netwerk in deze regio. Ze is een onmisbare kracht
                      in het team, essentieel voor het bevorderen van onze groei
                      en aanwezigheid in Latijns-Amerika.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div
          className="section mcb-section"
          style={{
            paddingTop: 60,
            paddingBottom: 20,
            backgroundColor: "#b8a892",
          }}
        >
          <div className="section_wrapper mcb-section-inner">
            <div className="wrap mcb-wrap one  valign-top clearfix">
              <div className="mcb-wrap-inner">
                <div className="column mcb-column three-fifth column_column">
                  <div className="column_attr">
                    <h2 style={{ margin: 0 }}>Heeft u een vraag?</h2>
                  </div>
                </div>
                <div className="column mcb-column two-fifth column_column">
                  <div
                    className="column_attr align_right"
                    style={{
                      padding: "10px 5px",
                      borderBottom: "1px solid rgba(0,0,0,.2)",
                    }}
                  >
                    <a
                      style={{ color: "#635f5e" }}
                      href="mailto:info@appmakelaar.nl"
                    >
                      Neem contact met ons op <i className="icon-right-open" />
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
export default Home;
